import React, { useState, useCallback, useEffect } from "react";
import PageItem from "./PageItem";
import paginate from "jw-paginate";

export default function Pagination({
  total,
  currentPage,
  pageSize,
  maxPages,
  getCurrent,
}) {
  const [hasil, setHasil] = useState({});

  console.log({ total, currentPage, pageSize, maxPages, getCurrent });

  const handleClick = useCallback(
    (number) => {
      getCurrent(number);
    },
    [getCurrent]
  );

  useEffect(() => {
    let page = paginate(total, currentPage, pageSize, maxPages);
    setHasil(page);
  }, [total, currentPage, pageSize, maxPages]);

  const pages = useCallback(() => {
    if (hasil.pages) {
      let viewPage = hasil.pages;
      return (
        <div className="flex items-center justify-between">
          {viewPage.map((item) => (
            <PageItem
              key={item}
              number={item}
              getClick={handleClick}
              active={currentPage}
            />
          ))}
        </div>
      );
    }
  }, [hasil, handleClick, currentPage]);

  return (
    <div className="flex justify-center space-x-10">
      <button
        className={`focus:outline-none ${
          currentPage === hasil.totalPages ? "" : "hover:scale-125"
        }`}
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <img
          src="/images/chevron.svg"
          alt="previous"
          className={`h-6 w-6 rotate-180 ${
            currentPage === 1 ? "opacity-30" : "cursor-pointer"
          }`}
        />
      </button>
      {pages()}
      <button
        className={`focus:outline-none ${
          currentPage === hasil.totalPages ? "" : "hover:scale-125"
        }`}
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === hasil.totalPages}
      >
        <img
          src="/images/chevron.svg"
          alt="next"
          className={`h-6 w-6 ${
            currentPage === hasil.totalPages ? "opacity-30" : "cursor-pointer"
          }`}
        />
      </button>
    </div>
  );
}
